import React, { useState, useEffect, useRef } from 'react'
import {
	Row,
	Col,
	Nav,
	Tabs,
	Tab,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronRight,
	faFileDownload
} from '@fortawesome/free-solid-svg-icons'
import styles from './CompanyDetails.module.scss'
import EButton from '../../components/bootstrap-extended/EButton'
import 'react-day-picker/lib/style.css'
import { useParams } from 'react-router-dom'
import { CSVLink } from 'react-csv'
import axios from 'axios'
import CompanyDetailsTab from '../../components/employers/EmployersDetail'
import CompanyJobsTab from '../../components/employers/EmployersJobList'

const CompanyDetails = () => {
	const csvLink = useRef<any | null>(null)
	const param = useParams()
	const companyId = param.id !== undefined ? parseInt(param.id) : ''

	const [company, setCompany] = useState<{ [key: string]: any }>({})
	const [jobAggregate, setJobAggregate] = useState<number>(0)
	const [dataExport, setDataExport] = useState<any[]>([])
	const [key, setKey] = useState<string>('details')
	const [isFirst, setIsFirst] = useState(true)


	const exportHeader = [
		{ label: 'Title', key: 'title' },
		{ label: 'Applicant', key: 'application' },
		{ label: 'Pending', key: 'pending_application' },
		{ label: 'Shortlisted', key: 'shortlisted_application' },
		{ label: 'Successful', key: 'successful_application' },
		{ label: 'Unsuccessful', key: 'unsuccessful_application' },
	]

	useEffect(() => {
		const getCompanyDetail = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_COMPANY as string + `/${companyId}`)
				setCompany(res.data)
			} catch (err) {
				return console.log(err)
			}
		}

		getCompanyDetail()
	}, [])

	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	const getAllJobs = async () => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_JOB as string + `?pageSize=${jobAggregate}&companyId=${companyId}`)
			setDataExport(res.data.jobs)
		} catch (err) {
			console.log(err)
		}
	}

	return (
		<div>
			<Row className={styles.searchCompRow}>
				{/* hide breadcrumb on xs */}
				<Col className="d-none d-sm-block">
					<Nav className={styles.breadCrumb}>
						<Nav.Item>
							<Nav.Link href="/employers" style={{ paddingLeft: '0px' }}>Employer</Nav.Link>
						</Nav.Item>
						<div className={styles.dateArrow}>
							<FontAwesomeIcon icon={faChevronRight} size="xs" color="#5B7493" />
						</div>
						<Nav.Item>
							<Nav.Link style={{ textDecoration: 'underline', color: '#233953' }}>Company Details</Nav.Link>
						</Nav.Item>
					</Nav>
				</Col>
				{key === 'jobs' && (
					<Col lg={2} md={2}>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<div onClick={getAllJobs}>
								<EButton
									buttonText='Export'
									icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
								/>
							</div>
							{dataExport.length > 0 ?
								<CSVLink
									data={dataExport}
									headers={exportHeader}
									filename={'Employers.csv'}
									ref={csvLink}
								/>
								: undefined
							}
						</div>
					</Col>
				)}
			</Row>

			<Tabs activeKey={key} variant='pills' className={styles.jobDetailsTab} onSelect={(key: string) => setKey(key)}>
				{/* tab 1 */}
				<Tab title='Company Details' eventKey='details'>
					<CompanyDetailsTab company={company} />
				</Tab>

				{/* tab 2 */}
				{
					isFirst ? (
						<Tab title='Jobs' eventKey='jobs'>
							{
								(key === 'jobs') && (
									<CompanyJobsTab companyId={companyId} setJobAggregate={setJobAggregate} setIsFirst={setIsFirst} />
								)
							}
						</Tab>
					) : (
						<Tab title='Jobs' eventKey='jobs'>
							<CompanyJobsTab companyId={companyId} setJobAggregate={setJobAggregate} setIsFirst={setIsFirst} />
						</Tab>
					)
				}
			</Tabs>
		</div>
	)
}

export default CompanyDetails